import React from 'react';
import { Shield, AlertTriangle, Lightbulb } from 'lucide-react';

const LongevityReportDisplay = ({ report, type = 'role' }) => {
  if (!report) return null;

  const {
    score,
    summary,
    resilient_tasks,
    resilient_skills,
    at_risk_tasks,
    at_risk_skills,
    strategic_advice
  } = report;

  const getScoreColors = (s) => {
    if (!s) return 'bg-gray-100 text-gray-800 border-gray-300';
    const lower = s.toLowerCase();
    if (lower.includes('high')) return 'bg-green-100 text-green-800 border-green-300';
    if (lower.includes('medium')) return 'bg-yellow-100 text-yellow-800 border-yellow-300';
    if (lower.includes('low')) return 'bg-red-100 text-red-800 border-red-300';
    return 'bg-gray-100 text-gray-800 border-gray-300';
  };

  const goodList = type === 'role' ? resilient_tasks : resilient_skills;
  const badList = type === 'role' ? at_risk_tasks : at_risk_skills;
  const goodTitle = type === 'role' ? 'Human-Required Tasks' : 'Resilient Skills';
  const badTitle = type === 'role' ? 'Automation-Prone Tasks' : 'At-Risk Skills';

  return (
    <div className="mt-6 p-6 bg-gray-50 rounded-lg border border-gray-200 text-left animate-fade-in">
      <h3 className="text-2xl font-bold text-gray-800 mb-4">
        {type === 'role' ? 'Market Risk Analysis' : 'Personal Resilience Analysis'}
      </h3>
      
      <div className="mb-4">
        <span className={`inline-block px-3 py-1 rounded-full text-sm font-bold border ${getScoreColors(score)}`}>
           Resilience Rating: {score}
        </span>
      </div>
      
      <p className="text-gray-700 italic mb-6">{summary}</p>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
        <div className="bg-white p-4 rounded-lg border border-green-200 shadow-sm">
          <h4 className="font-semibold text-gray-800 mb-3 flex items-center">
            <Shield className="w-5 h-5 mr-2 text-green-600" />
            {goodTitle}
          </h4>
          <ul className="list-disc list-inside space-y-1 text-gray-600">
            {goodList?.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>
        </div>
        
        <div className="bg-white p-4 rounded-lg border border-red-200 shadow-sm">
          <h4 className="font-semibold text-gray-800 mb-3 flex items-center">
            <AlertTriangle className="w-5 h-5 mr-2 text-red-600" />
            {badTitle}
          </h4>
          <ul className="list-disc list-inside space-y-1 text-gray-600">
            {badList?.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>
        </div>
      </div>

      {strategic_advice && (
        <div className="mt-6">
          <h4 className="font-semibold text-gray-800 mb-3 flex items-center">
            <Lightbulb className="w-5 h-5 mr-2 text-yellow-600" />
            Strategic Advice (5-Year Horizon)
          </h4>
          <p className="text-gray-700 p-4 bg-white border border-blue-200 rounded-lg shadow-sm leading-relaxed">
            {strategic_advice}
          </p>
        </div>
      )}
    </div>
  );
};

export default LongevityReportDisplay;